import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/joy';

interface PortraitPopupProps {
  show: boolean;
}

const PortraitPopup: React.FC<PortraitPopupProps> = ({ show }) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <Box
      className='fixed inset-0 z-[100000] flex items-center justify-center'
      sx={{
        backgroundColor: 'rgba(50, 56, 62, 0.6)',
        backdropFilter: 'blur(1px)',
        pointerEvents: 'none'
      }}
    >
      <Box
        className='mx-4'
        sx={{
          backgroundColor: 'background.surface',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0px 1px 2px 0px rgba(21, 21, 21, 0.08), 0px 2px 4px 0px rgba(21, 21, 21, 0.08)',
          pointerEvents: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 0,
          alignItems: 'flex-start',
          width: '100%',
          maxWidth: '100%'
        }}
      >
        <Typography
          level='body-sm'
          sx={{
            color: 'neutral.outlinedColor',
            fontSize: '14px',
            lineHeight: 1.5,
            fontWeight: 400,
            fontFamily: '"Open Sans", sans-serif',
            width: '100%'
          }}
        >
          {t('crew_view.portrait_popup')}
        </Typography>
      </Box>
    </Box>
  );
};

export default PortraitPopup;
